import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './ProfileHeader.style';
import {ProfileHeaderProps} from './ProfileHeader.types';

export const ProfileHeader = ({
  name = '',
  createdOn = '',
  referrerName = '',
  expirationTime = '',
  expired = false,
}: ProfileHeaderProps) => {
  const expiresText = expired ? 'Expired' : 'Expires';
  const formattedExpirationDate = getDateUtilDefaultInstance().formatDate(
    expirationTime,
    'MMM d, yyyy',
  );

  const textStyle = expired ? styles.expired : styles.notExpired;

  return (
    <View style={styles.base}>
      <View style={styles.infoColumn}>
        <Text variant="large">{name}</Text>
        <View style={styles.optaviaTextContainer}>
          <Text style={styles.dateText}>
            Added on{' '}
            {getDateUtilDefaultInstance().formatDate(createdOn, 'MMM d, yyyy')}{' '}
            ({'Client Referral'})
          </Text>
        </View>
        <View>
          <Text style={styles.dateText}>
            From {referrerName} -
            <Text style={textStyle} isBold={expired}>
              {' '}
              {expiresText}{' '}
              <Text testID="expirationDate">{formattedExpirationDate}</Text>
            </Text>
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ProfileHeader;
